/**
 * NOTE: The colors listed here are not part of any theme but a set of utility constants
 * that is provided for a better readability when managing some colors-related math
 */

export const WHITE = 0xffffffff;

export const TRANSPARENT = 0x00000000;
